module.exports = __webpack_public_path__ + "img/schnittkante_silbergrau_ral9006.bac21e03.jpg";